import React from "react";

export const InstagramIcon = ({
  width = "18.176",
  height = "18.176",
  fill = "#fff",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.176 18.178"
      {...{ width, height, fill }}
    >
      <path
        id="Forma_1"
        data-name="Forma 1"
        d="M1355.57,5667.5a5.022,5.022,0,0,1-5.017-5.017v-8.145a5.022,5.022,0,0,1,5.017-5.017h8.144a5.021,5.021,0,0,1,5.015,5.017v8.145a5.021,5.021,0,0,1-5.015,5.017Zm-3.4-13.161v8.145a3.407,3.407,0,0,0,3.4,3.4h8.144a3.406,3.406,0,0,0,3.4-3.4v-8.145a3.407,3.407,0,0,0-3.4-3.4h-8.144A3.408,3.408,0,0,0,1352.167,5654.34Zm2.792,4.072a4.684,4.684,0,1,1,4.684,4.684A4.689,4.689,0,0,1,1354.959,5658.412Zm1.613,0a3.071,3.071,0,1,0,3.071-3.071A3.073,3.073,0,0,0,1356.572,5658.412Zm7.115-4.032a1.182,1.182,0,1,1,.836.347A1.189,1.189,0,0,1,1363.686,5654.38Z"
        transform="translate(-1350.554 -5649.323)"
      />
    </svg>
  );
};
